import * as PropTypes from "prop-types";
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100%",
    padding: theme.spacing(2),
    borderBottom: "1px solid rgba(0,0,0,0.34)",
    position: "relative",
  },
  closeContainer: {
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
}));

function ForegroundBlobFakeModalHeaderV2({ children, onClose }) {
  const classes = useStyles({});

  return (
    <div className={classes.wrapper}>
      <div className={classes.content}>{children}</div>
      <div className={classes.closeContainer}>
        <IconButton
          className={classes.close}
          onClick={onClose}
          id="headerCloseButton"
        >
          <Close />
        </IconButton>
      </div>
    </div>
  );
}

ForegroundBlobFakeModalHeaderV2.propTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
};

export default ForegroundBlobFakeModalHeaderV2;
